const SIMPLE_ICON_SLUG: Record<string, string> = {
  instagram: 'instagram',
  tiktok: 'tiktok',
  youtube: 'youtube',
  facebook: 'facebook',
  'twitter-x': 'x',
  twitter: 'x',
  x: 'x',
  telegram: 'telegram',
  discord: 'discord',
  spotify: 'spotify',
  threads: 'threads',
  twitch: 'twitch',
  linkedin: 'linkedin',
  pinterest: 'pinterest',
  kwai: 'kwai',
};

/** Brand hex without # — readable on light and dark surfaces */
const BRAND_COLOR: Record<string, string> = {
  instagram: 'E4405F',
  tiktok: '25F4EE',
  youtube: 'FF0000',
  facebook: '1877F2',
  'twitter-x': 'A8B3C5',
  twitter: 'A8B3C5',
  x: 'A8B3C5',
  telegram: '26A5E4',
  discord: '5865F2',
  spotify: '1DB954',
  threads: 'A8B3C5',
  twitch: '9146FF',
  linkedin: '0A66C2',
  pinterest: 'E60023',
  kwai: 'FF4906',
};

type NetworkIconProps = {
  slug: string;
  name?: string;
  size?: number;
  className?: string;
};

export function NetworkIcon({ slug, name, size = 20, className }: NetworkIconProps) {
  const iconSlug = SIMPLE_ICON_SLUG[slug] ?? slug;
  const color = BRAND_COLOR[slug] ?? '3B82F6';
  const label = name ?? slug;

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-md bg-[var(--color-bg)] ring-1 ring-[var(--color-border)] ${className ?? ''}`}
      style={{ width: size + 8, height: size + 8 }}
      title={label}
    >
      <img
        src={`https://cdn.simpleicons.org/${iconSlug}/${color}`}
        alt=""
        width={size}
        height={size}
        className="object-contain"
        loading="lazy"
        onError={(e) => {
          const el = e.currentTarget;
          el.style.display = 'none';
          const fallback = el.nextElementSibling as HTMLElement | null;
          if (fallback) fallback.style.display = 'inline-flex';
        }}
      />
      <span
        className="hidden h-full w-full items-center justify-center text-[10px] font-bold uppercase text-fg"
        aria-hidden
      >
        {label.slice(0, 2)}
      </span>
    </span>
  );
}
